/* global axios */
import ApiClient from './ApiClient';

class CustomAttributeBundlesAPI extends ApiClient {
  constructor() {
    super('custom_attribute_bundles', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(bundleData) {
    return axios.post(this.url, { custom_attribute_bundle: bundleData });
  }
}

export default new CustomAttributeBundlesAPI();
